<script>
import { mapGetters } from 'vuex'

import UserCard from '@components/contact-us-page/user-card.vue'

import Translatable from '@src/mixins/translatable.js'

export default {
  components: {
    UserCard,
  },
  mixins: [Translatable],
  computed: {
    ...mapGetters('contactUs', ['pageData']),
    teamList() {
      if (!this.pageData.team) {
        return []
      }
      const list = this.pageData.team
      return list.map((data, index) => {
        const localizedPosition =
          data.position[this.currentLanguage] || data.position.en || ''

        return {
          _id: index + 1,
          image: [data.web_image, data.app_image],
          name: data.name,
          position: localizedPosition,
        }
      })
    },
  },
}
</script>

<template>
  <div class="section-container">
    <p
      class="description-title"
      v-html="getTranslatedContent('team_title', pageData.content)"
    ></p>
    <div class="content">
      <UserCard v-for="user in teamList" :key="user._id" :user="user" />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@design';

.section-container {
  margin-top: 110px;
}

.content {
  display: flex;
  width: 1140px;
  flex-wrap: wrap;
  justify-content: space-between;
}

.description-title {
  font-family: Open Sans Bold, sans-serif;
  font-weight: bold;
  font-style: normal;
  text-transform: uppercase;
  font-size: 26px;
  line-height: 34px;
  color: $dark-blue;
  padding-bottom: 50px;
}

@media only screen and (max-width: $screen-width-xs) {
  .content {
    width: 100%;
    justify-content: center;
  }

  .section-container {
    margin-top: 56px;
  }

  .description-title {
    font-size: 18px;
  }
}
</style>
